import {
  ValueSet,
  ValueSetExpansion,
  ValueSetExpansionContains,
} from 'fhir/r4';
import fhirDao from '../dao/fhirDao';

/**
 * Takes an array of codes and a ValueSet as input. Looks for code matches in valueSet and returns matching entries.
 * @param {Array} arrayOfCodes Strings representing codes
 * @param {Array} valueSetToLookForMatchesIn Array of ValueSet entries that contain a String code property
 * @returns ValueSet entries with codes matching a code in arrayOfCodes
 */
const getMatchingVsEntriesForGivenCodes = function (
  arrayOfCodes,
  valueSetToLookForMatchesIn
) {
  //toLowerCase allows case insensitive matching later on
  const lowerCaseCodes = arrayOfCodes.map((code) => code.toLowerCase());

  const arrayWithMatchingExtractedInfo = valueSetToLookForMatchesIn.filter(
    (vsEntry) =>
      vsEntry.code && lowerCaseCodes.includes(vsEntry.code.toLowerCase())
  );

  return arrayWithMatchingExtractedInfo;
};

const getFilteredVS = async (displayVal: string, valueSetUrl: string) => {
  try {
    const response = await fhirDao.filterExpandedValueSet(
      valueSetUrl,
      displayVal
    );

    if (response.status == 200) {
      const expandedValueSet = response.data as ValueSet;
      const expansionResult = expandedValueSet.expansion as ValueSetExpansion;
      const resultingList: ValueSetExpansionContains[] =
        expansionResult.contains != undefined ? expansionResult.contains : [];
      const result =
        resultingList.length > 800
          ? resultingList.slice(0, 800)
          : resultingList; //Limits array size for performance reasons
      return result;
    } else {
      console.log('Fehler bei ValueSet-Abfrage');
      return [];
    }
  } catch (e) {
    console.error('Fehler bei ValueSet-Abfrage');
    console.log(e);
    return [];
  }
};

export default { getMatchingVsEntriesForGivenCodes, getFilteredVS };
